module.exports = __webpack_public_path__ + "img/alarm-notice.8ca5691f.svg";